import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import api, { fileUrl } from "../lib/api";

export function BundleGrid() {
  const [bundles, setBundles] = useState([]);
  useEffect(() => { api.get("/bundles").then((r) => setBundles(r.data)); }, []);
  if (bundles.length === 0) return null;
  const $ = (c) => `$${(c / 100).toFixed(2)}`;
  return (
    <section className="mb-16" data-testid="bundle-grid">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="overline text-[#d4af37] flex items-center gap-2"><Package className="w-4 h-4" /> Bundles</div>
          <h2 className="font-serif text-3xl text-[#0a192f] mt-2">Better together. Priced kinder.</h2>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-8">
        {bundles.map((b) => (
          <Link key={b.id} to={`/bundle/${b.id}`} data-testid={`bundle-card-${b.id}`} className="card-flat bg-[#0a192f] text-white p-8 grid sm:grid-cols-[1fr_auto] gap-6 group">
            <div>
              <div className="overline text-[#d4af37]">Save {b.discount_pct}%</div>
              <div className="font-serif text-3xl mt-2 leading-tight">{b.name}</div>
              <p className="text-white/70 text-sm mt-3 line-clamp-2">{b.description}</p>
              <div className="mt-5 flex items-end gap-3">
                <span className="font-serif text-3xl">{$(b.price_cents)}</span>
                <span className="text-white/50 line-through mb-1">{$(b.full_price_cents)}</span>
              </div>
            </div>
            <div className="flex -space-x-6 items-center">
              {b.products.slice(0, 3).map((p, i) => (
                <div key={p.id} style={{ transform: `rotate(${(i - 1) * 6}deg)` }} className="w-20 h-28 bg-[#f4f5f7] overflow-hidden border-2 border-[#0a192f] shadow-xl group-hover:-translate-y-1 transition-transform">
                  {p.cover_key ? <img src={fileUrl(p.cover_key)} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center font-serif text-[#0a192f] text-2xl">{p.name?.[0]}</div>}
                </div>
              ))}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
